import { render } from "./GovDetail.vue?vue&type=template&id=7875519c&scoped=true"
import script from "./GovDetail.vue?vue&type=script&lang=js"
export * from "./GovDetail.vue?vue&type=script&lang=js"

import "./GovDetail.vue?vue&type=style&index=0&id=7875519c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7875519c"]])

export default __exports__